export const PAGE_LOAD = 'military-discount.page-load';
export const GET_STARTED_LINK = 'military-discount-start-link';
export const FAQ_EXPEND = 'military-discount-faq';
export const FAQ_LINKS = 'military-discount-faq-links';
export const VIRTUAL_ID_BTN = 'military-discount-virtual-id-btn';
export const RESTART_APP_LINK = 'military-discount-restart-app-link';

/* The one event on this page that is a New Relic page action rather than a
/* life-cycle event - see analytics/newrelic.js for why. Named alongside the
/* rest regardless: one list of event names is worth more than a split that
/* only records which pipe each one goes down. */
export const IDME_ACCESS_DENIED = 'military-discount-idme-access-denied';
